import { FEATURED_OFFERS_LOGO_GET_SUCCESS, FEATURED_OFFERS_LOGO_GET_FAILURE } from '../actions/types';
import featuredOffersLogoConfig from '../configs';

const initialState = {
  config: featuredOffersLogoConfig,
  merchants: [],
  isLoading: false,
  isLoaded: false,
};

/**
 * @param {object} state
 * @param {object} action
 * @return {object}
 */
const featuredOffersLogo = (state = initialState, action) => {
  switch (action.type) {
    case FEATURED_OFFERS_LOGO_GET_SUCCESS: {
      const placements = action.payload.response;
      return {
        ...state,
        merchants: placements.map(({ merchant }) => merchant),
        isLoading: false,
        isLoaded: true,
      };
    }
    case FEATURED_OFFERS_LOGO_GET_FAILURE: {
      return {
        ...state,
        merchants: [],
        isLoading: false,
        isLoaded: true,
      }; // we'd have to decide what to do with error state
    }
    default: {
      const { options = {} } = action;
      // Handle setting isLoading to true for raw OCAPI action
      if (options.success === FEATURED_OFFERS_LOGO_GET_SUCCESS) {
        return { ...state, isLoading: true };
      }

      return state;
    }
  }
};

export default featuredOffersLogo;
